import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";

import Layout from "layouts/DashboardManage";
import Pagination from "components/Pagination";
import ManageDataTable from "components/ManageDataTable";
import Notification from "components/Notification";
import { getAllImportedFiles } from "store/actions/fileAction";
import { SpinnerRainbow } from "components/Spinner";
import NoData from "components/NoData";
import Translate from "helpers/Translate";
import SearchFilters from "../DeletedFileLogs/searchFilter";
import FileDetails from "../FileHistory/FileDetails";

// Styles
import "../DeletedFileLogs/deletedFilesLogs.scss";

const ImportedFileLogs = () => {
  const dispatch = useDispatch();
  const isLoadingImportedFile = useSelector(
    state => state.file.isLoadingImportedFile
  );
  const allImportedFiles = useSelector(state => state.file.getImportedFiles);

  const [selectedOriginalFilename, setSelectedOriginalFilename] = useState("");
  const [selectedPageLimit, setSelectedPageLimit] = useState(10);

  // Get file list
  useEffect(() => {
    dispatch(getAllImportedFiles({}));
    // eslint-disable-next-line
  }, [dispatch]);
  const handleFilterData = ({ page = 1, resetFilter }) => {
    dispatch(
      getAllImportedFiles({
        rawFilename: !resetFilter ? selectedOriginalFilename : "",
        page,
        limit: !resetFilter ? selectedPageLimit : 10
      })
    );
  };
  const handleResetFilter = () => {
    Notification.confirm(Translate({ id: "sure_to_reset" }), {
      onOk: () => {
        setSelectedOriginalFilename("");
        setSelectedPageLimit("");

        handleFilterData({
          resetFilter: true
        });
      },
      labelOk: Translate({ id: "yes" }),
      labelCancel: Translate({ id: "no" })
    });
  };
  const onPageChange = data => {
    const targetPage = parseInt(data.selected) + 1;
    handleFilterData({ page: targetPage });
  };

  const hasData = () => {
    return (
      !isLoadingImportedFile &&
      allImportedFiles?.data &&
      allImportedFiles.data.length > 0
    );
  };
  const getFileImportDate = item => {
    let importDate = "--";

    if (item?.imported_at) {
      importDate = moment(item.imported_at).format("YYYY-MM-DD H:m");
    }
    return importDate;
  };
  return (
    <Layout>
      <div className="manage">
        <Link className="back mb-20" to="/manage">
          <i className="fas fa-long-arrow-alt-left"></i>
          {Translate({ id: "back_to_manage_dashboard" })}
        </Link>
        <div className="manage-page-heading">
          <span className="manage-page-icon tone-sky" aria-hidden="true">
            <i className="fas fa-file-import"></i>
          </span>
          <div className="manage-page-heading__text">
            <h1 className="title">{Translate({ id: "imported_file_logs" })}</h1>
            <p className="manage-page-subtitle">
              {Translate({ id: "imported_file_logs_description" })}
            </p>
          </div>
        </div>

        {/* Filters */}
        <h4 className="mb-5">{Translate({ id: "filters" })}:</h4>
        <div className="file-deleted__filters mb-20">
          <SearchFilters
            handleFilterData={handleFilterData}
            handleResetFilter={handleResetFilter}
            selectedOriginalFilename={selectedOriginalFilename}
            setSelectedOriginalFilename={setSelectedOriginalFilename}
            selectedPageLimit={selectedPageLimit}
            setSelectedPageLimit={setSelectedPageLimit}
          />
        </div>

        {isLoadingImportedFile && <SpinnerRainbow />}

        {!isLoadingImportedFile && (
          <ManageDataTable
            footer={
              hasData() ? (
                <Pagination
                  onPageChange={onPageChange}
                  data={allImportedFiles && allImportedFiles.meta}
                />
              ) : null
            }
          >
            <table className="file-deleted">
              <thead>
                <tr>
                  <th className="left">{Translate({ id: "file_id" })} </th>
                  <th className="left">
                    {Translate({ id: "original_filename" })}
                  </th>
                  <th className="left">{Translate({ id: "imported_by" })} </th>
                  <th className="left">{Translate({ id: "client_name" })} </th>
                  <th className="left">
                    {Translate({ id: "department_name" })}
                  </th>
                  <th className="left">
                    {Translate({ id: "date_of_file_import" })}
                  </th>
                  <th className="action-col">
                    {Translate({ id: "action" })}
                  </th>
                </tr>
              </thead>

              <tbody>
                {hasData() &&
                  allImportedFiles?.data?.map(item => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.raw_filename}</td>
                      <td>{item.imported_by?.fullname}</td>
                      <td>{item.client?.name}</td>
                      <td>{item.department?.name}</td>
                      <td>{getFileImportDate(item)}</td>
                      <td className="action-col">
                        <div className="manage-data-table-actions">
                          <FileDetails fileDoc={item} />
                        </div>
                      </td>
                    </tr>
                  ))}

                {!hasData() && (
                  <tr>
                    <td colSpan="100">
                      <NoData />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </ManageDataTable>
        )}
      </div>
    </Layout>
  );
};
export default ImportedFileLogs;
